import React from 'react';
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import './fileSelectionModal.css';

export default class FileSelectionModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
			file: null,
			dragOver: false,
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
				file: null,
				dragOver: false,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }
	
	onDrop(files) {
		if(files && files.length > 0) {
			this.setState({
				file: files[0]
			});
		}
	}

    close(result) {
        if (result) {
            this.state.promiseResolve(this.state.file);
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
			file: null,
			dragOver: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

	renderDropzoneBody() {
		if (this.state.file == null) {
			return (
				<div className="dropzone-label">
					<span>Перенесите файл на эту область<br/><b>или</b><br/>нажмите для открытия диалога выбора файла.</span>
				</div>
			);
		} else {
			return (
				<div className="dropzone-label">
                    <img src="/img/file_icon.png" className="dropzone-icon" alt="file" />
					<span>{this.state.file.name}</span>
				</div>
			);
		}
	}

    render() {
		let dragzoneClass = "dropzone has-advanced-upload" + (this.state.dragOver ? " is-dragover" : "");
        return (
            <Modal show={this.state.isOpen} 
				onHide={() => this.close(false)} 
				aria-labelledby="ModalHeader" 
				backdrop="static"
			>
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>
						{this.state.title}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<Dropzone multiple={false}
						onDrop={files => this.onDrop(files)}
						styles={{}}
						className={dragzoneClass}
					>
						{this.renderDropzoneBody()}
					</Dropzone>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' 
						onClick={() => this.close(true)}
						disabled={this.state.file == null}
					>
						Отправить
					</button>
                    <Modal.Dismiss className='btn btn-default'>
						Отмена
					</Modal.Dismiss>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/fileSelectionModal.jsx